import { childEndpoints } from "@/config/endpoints";
import axiosInstance from "@/lib/axios";
import { queryClient } from "@/lib/queryClient";
import { useQuery } from "@tanstack/react-query";

export function useChilds(filters?: Record<string, any>) {
  const query = useQuery({
    queryKey: ["childs", filters],
    enabled: Boolean(filters),
    queryFn: async () => {
      const response = await axiosInstance.get(childEndpoints, {
        params: filters,
      });
      return response.data;
    },
  });

  return {
    childs: query.data?.children ?? [],
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
  };
}

/**
 * Deals-list bust. With a `leadId` it is exact to that lead's list
 * (`["childs", { leadId }]` — the shape `ChildProvider` mounts), so a
 * tenant-wide socket push refetches only the drawer open ON that lead; the
 * bare call keeps the prefix for the actor's own mutation paths.
 */
export const refetchChilds = (leadId?: number | string | null) => {
  const id = leadId != null && leadId !== "" ? Number(leadId) : null;
  if (id == null || !Number.isFinite(id)) {
    queryClient.invalidateQueries({ queryKey: ["childs"] });
    return;
  }
  queryClient.invalidateQueries({
    predicate: (q) =>
      q.queryKey[0] === "childs" &&
      Number((q.queryKey[1] as { leadId?: unknown } | undefined)?.leadId) === id,
  });
};
